import { render } from "./TipTapEditor.vue?vue&type=template&id=3b46deaf"
import script from "./TipTapEditor.vue?vue&type=script&lang=js"
export * from "./TipTapEditor.vue?vue&type=script&lang=js"

import "./TipTapEditor.vue?vue&type=style&index=0&id=3b46deaf&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__